import { render, staticRenderFns } from "./KeywordCategoryAddForm.vue?vue&type=template&id=73646ca2"
import script from "./KeywordCategoryAddForm.vue?vue&type=script&lang=js"
export * from "./KeywordCategoryAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports